import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { getThemeValueByKey } from '@statsbomb/kitbag-themes';
import { MENU_ITEM_SIZE } from './Menu.constants.js';
import { SURFACE_COLOUR_VARIANTS } from '../../constants/variants.js';

var getMenuOpacity = function getMenuOpacity(_ref) {
  var $isOpaque = _ref.$isOpaque,
    $isActive = _ref.$isActive,
    $isDisabled = _ref.$isDisabled,
    opacity = _ref.theme.opacity;
  if ($isDisabled) return opacity.disabled;
  if ($isOpaque || $isActive) return 1;
  return opacity.secondary;
};
var getMenuSpacing = function getMenuSpacing(_ref2) {
  var theme = _ref2.theme,
    $size = _ref2.$size;
  switch ($size) {
    case MENU_ITEM_SIZE.TOUCH:
      return "".concat(theme.sizing.regular, " ").concat(theme.sizing.large);
    case MENU_ITEM_SIZE.SMALL:
      return theme.sizing.small;
    default:
      return "".concat(theme.sizing.tiny, " ").concat(theme.sizing.small);
  }
};
var MENU_ITEM_HEIGHTS = _defineProperty(_defineProperty(_defineProperty({}, MENU_ITEM_SIZE.LARGE, '3.5rem'), MENU_ITEM_SIZE.REGULAR, '2.5rem'), MENU_ITEM_SIZE.SMALL, '2rem');
var getMenuHeight = function getMenuHeight(_ref3) {
  var $size = _ref3.$size;
  switch ($size) {
    case MENU_ITEM_SIZE.LARGE:
      return MENU_ITEM_HEIGHTS[MENU_ITEM_SIZE.LARGE];
    case MENU_ITEM_SIZE.REGULAR:
      return MENU_ITEM_HEIGHTS[MENU_ITEM_SIZE.REGULAR];
    default:
      return 'initial';
  }
};
var getMenuItemSize = function getMenuItemSize(_ref4) {
  var theme = _ref4.theme,
    $size = _ref4.$size;
  return {
    height: getMenuHeight({
      $size: $size
    }),
    padding: getMenuSpacing({
      $size: $size,
      theme: theme
    }),
    width: $size === MENU_ITEM_SIZE.TOUCH ? '100vw' : '12.5rem'
  };
};
var applyPositioning = function applyPositioning(_ref5) {
  var $bottom = _ref5.$bottom,
    $left = _ref5.$left,
    $right = _ref5.$right,
    $top = _ref5.$top;
  if (!($bottom || $left || $right || $top)) return null;
  return {
    bottom: Number.isInteger($bottom) && "".concat($bottom, "px"),
    left: Number.isInteger($left) && "".concat($left, "px"),
    position: 'absolute',
    right: Number.isInteger($right) && "".concat($right, "px"),
    top: Number.isInteger($top) && "".concat($top, "px")
  };
};
var getMenuBackgroundColour = function getMenuBackgroundColour(_ref6) {
  var theme = _ref6.theme,
    $variant = _ref6.$variant;
  return getThemeValueByKey({
    findKey: SURFACE_COLOUR_VARIANTS[$variant].background,
    tokens: theme
  });
};
var getMenuItemBackgroundColour = function getMenuItemBackgroundColour(_ref7) {
  var theme = _ref7.theme,
    $isActive = _ref7.$isActive,
    $variant = _ref7.$variant;
  var defaultBackgroundColour = getThemeValueByKey({
    findKey: SURFACE_COLOUR_VARIANTS[$variant].background,
    tokens: theme
  });
  var activeBackgroundColour = getThemeValueByKey({
    findKey: SURFACE_COLOUR_VARIANTS[$variant].selectedBackground,
    tokens: theme
  });
  if ($isActive) return activeBackgroundColour;
  return defaultBackgroundColour;
};
var getMenuItemTextColour = function getMenuItemTextColour(_ref8) {
  var theme = _ref8.theme,
    $variant = _ref8.$variant;
  var defaultTextColour = getThemeValueByKey({
    findKey: SURFACE_COLOUR_VARIANTS[$variant].text,
    tokens: theme
  });
  return defaultTextColour;
};
var getMenuItemAlignment = function getMenuItemAlignment(_ref9) {
  var $size = _ref9.$size,
    $iconPosition = _ref9.$iconPosition,
    theme = _ref9.theme;
  if ($iconPosition === 'left') {
    return {
      alignItems: 'center',
      flexDirection: 'row',
      gap: theme.sizing.tiny,
      justifyContent: 'flex-start'
    };
  }
  if ($size === MENU_ITEM_SIZE.LARGE) {
    return {
      alignItems: 'flex-start',
      flexDirection: 'column',
      justifyContent: 'center'
    };
  }
  return {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  };
};
var getActiveOverlayBackgroundColour = function getActiveOverlayBackgroundColour(_ref10) {
  var theme = _ref10.theme,
    $variant = _ref10.$variant;
  var activeBackgroundColour = getThemeValueByKey({
    findKey: SURFACE_COLOUR_VARIANTS[$variant].activeBackground,
    tokens: theme
  });
  return theme.applyOpacity(activeBackgroundColour, 'highlight');
};

export { applyPositioning, getActiveOverlayBackgroundColour, getMenuBackgroundColour, getMenuItemAlignment, getMenuItemBackgroundColour, getMenuItemSize, getMenuItemTextColour, getMenuOpacity };
//# sourceMappingURL=Menu.styles.helper.js.map
